// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__18OQ6","bigColWidth":"Table_bigColWidth__1zM39","biggerColWidth":"Table_biggerColWidth__7Ml1V","row":"Table_row__38ton","col":"Table_col__3vSUn"};